import { LupaIcon } from "assets/icons/LupaIcon";
import { AppSectionHeaderFilterBox } from "components/AppSectionHeaderFilterBox";
import { Input } from "components/Input/Input";
import { Select } from "components/Select/Select";
import { useOrganismosList } from "./OrganismosListCtx";
import { ChangeEvent } from "react";

export function OrganismosListPageFilters()
{
  const {
    filterName,
    setFilterName,
  } = useOrganismosList();

  return (
<>
<AppSectionHeaderFilterBox
  onReset={() =>
  {
  }}
  isDisabled={false}
>
  <Input
    size="sm"
    id="nombre"
    onChange={(e: ChangeEvent<HTMLInputElement>) =>
    {
      setFilterName(e.target.value)
    }}
    placeholder="Buscar nombre"
    values={{
      nombre: filterName,
    }}
    startIcon={<LupaIcon />}
  />
</AppSectionHeaderFilterBox>
</>
  )
}
